export default "__VITE_ASSET__725aa3b7__"